export default __webpack_public_path__ + "static/media/iconfont.920b99f9.woff";